import { Link, Navigate, useSearchParams } from 'react-router-dom';
import { SignupForm } from '@/features/auth/components/SignupForm';
import { OAuthButtons } from '@/features/auth/components/OAuthButtons';
import { usePublicConfig } from '@/features/auth/hooks/usePublicConfig';
import { usePaperTheme } from '@/hooks/usePaperTheme';

export function SignupPage() {
  usePaperTheme();
  const [searchParams] = useSearchParams();
  const invite = searchParams.get('invite');
  const { mode, loading } = usePublicConfig();

  if (loading) {
    return <div className="min-h-screen bg-paper" />;
  }

  if (mode !== 'open' && !invite) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen bg-paper text-charcoal-soft">
      <nav className="mx-auto flex max-w-6xl items-center justify-between px-6 py-5">
        <Link to="/" className="text-lg font-semibold tracking-tight-ish text-charcoal">
          clyra<span className="text-teal-500">.</span>
        </Link>
        <Link to="/login" className="text-petit text-charcoal-muted hover:text-charcoal transition-colors">
          Sign in
        </Link>
      </nav>

      <main className="mx-auto flex max-w-sm flex-col px-6 pt-12 pb-20">
        <div className="mb-8">
          <h1 className="text-2xl font-semibold tracking-tight-ish text-charcoal">
            Create your account
          </h1>
          <p className="mt-1 text-petit text-charcoal-muted">
            Ten diagrams per account, no credit card.
          </p>
        </div>

        <div className="rounded-xl border border-stone-subtle bg-paper-raised p-6 shadow-paper-sm">
          <OAuthButtons label="Sign up with" />
          <div className="mt-4">
            <SignupForm />
          </div>
        </div>

        <p className="mt-6 text-center text-petit text-charcoal-muted">
          Already have an account?{' '}
          <Link to="/login" className="text-teal-600 hover:text-teal-500 transition-colors">
            Sign in
          </Link>
        </p>
      </main>
    </div>
  );
}
